/* Four-category offers. Shopify remains the authority for active checkout prices. */
(function (root) {
  'use strict';
  const RULES = {
    scrunchie: {label:'Scrunchies', size:4, rate:1, title:'Scrunchies Buy 3 Get 1'},
    pillowcase: {label:'Pillowcases', size:4, rate:1, title:'Pillowcases Buy 3 Get 1'},
    'eye-mask': {label:'Eye masks', size:2, rate:0.5, title:'Eye Masks Second Item Half Price'},
    bonnet: {label:'Bonnets', size:2, rate:0.5, title:'Bonnets Second Item Half Price'}
  };
  function calculate(cart, metadata, welcome) {
    const groups = Object.fromEntries(Object.keys(RULES).map(key => [key,{count:0,rewards:0,saving:0}]));
    const lines = (cart.items || []).map(item => {
      const meta = metadata[item.key] || {};
      const quantity = Math.max(0, Number(item.quantity) || 0);
      const price = Number(item.original_price) || 0;
      const gift = meta.gift === true || price === 0;
      const sale = !gift && Number(meta.compare) > price;
      const category = RULES[meta.category] ? meta.category : '';
      const eligible = Boolean(meta.eligible && category && !sale && !gift && !item.selling_plan_allocation && price > 0);
      if (eligible) groups[category].count += quantity;
      return {key:item.key,item,quantity,price,gift,sale,category,eligible,rewards:0,saving:0,regular:gift?0:Math.max(price,Number(meta.compare)||0)*quantity};
    });
    for (const [key,group] of Object.entries(groups)) {
      const rule = RULES[key];
      group.rewards = Math.floor(group.count/rule.size);
      let remaining = group.rewards;
      const sorted = lines.filter(line => line.eligible && line.category === key).sort((a,b) => a.price-b.price || (Number(a.item.final_line_price)/a.quantity)-(Number(b.item.final_line_price)/b.quantity) || a.key.localeCompare(b.key));
      for (const line of sorted) {
        line.rewards = Math.min(remaining,line.quantity);
        line.saving = Math.round(line.price * rule.rate * line.rewards);
        group.saving += line.saving;
        remaining -= line.rewards;
      }
    }
    const current = lines.reduce((sum,line)=>sum+line.price*line.quantity,0);
    const regular = lines.reduce((sum,line)=>sum+line.regular,0);
    const saving = Object.values(groups).reduce((sum,group)=>sum+group.saving,0);
    const welcomeSaving = welcome ? Math.round((current-saving)*0.15) : 0;
    return {lines,groups,current,regular,saleSaving:regular-current,saving,welcomeSaving,total:current-saving-welcomeSaving};
  }
  function itemIdentity(item) {
    const properties=Object.entries(item.properties||{}).sort(([a],[b])=>a.localeCompare(b));
    return JSON.stringify([item.variant_id,item.original_price,properties,item.selling_plan_allocation||null,item.parent_relationship||null]);
  }
  function displayGroups(lines) {
    const groups=new Map();
    for(const line of lines) {
      const item=line.item, restricted=line.gift||item.selling_plan_allocation||item.parent_relationship||item.has_components||item.instructions?.can_update_quantity===false||item.instructions?.can_remove===false;
      const identity=restricted?line.key:itemIdentity(item);
      let group=groups.get(identity);
      if(!group){group={...line,identity,members:[],quantity:0,rewards:0,saving:0,regular:0,item:{...item,quantity:0,final_line_price:0,line_level_discount_allocations:[]}};groups.set(identity,group);}
      group.members.push(line);group.quantity+=line.quantity;group.rewards+=line.rewards;group.saving+=line.saving;group.regular+=line.regular;
      group.item.quantity+=line.quantity;group.item.final_line_price+=Number(item.final_line_price)||0;
      group.item.line_level_discount_allocations.push(...(item.line_level_discount_allocations||[]));
    }
    return [...groups.values()];
  }
  function quantityRequest(group,target) {
    const current=group.reduce((sum,item)=>sum+item.quantity,0);
    if(target>current)return {endpoint:'change',body:{id:group[0].key,quantity:group[0].quantity+target-current}};
    let remaining=target;
    const updates={};
    for(const item of group){updates[item.key]=Math.min(remaining,item.quantity);remaining-=updates[item.key];}
    return {endpoint:'update',body:{updates}};
  }
  function rewardSubtotal(cart) {
    // Complimentary gifts cost zero; Shopify's total includes every discount.
    return Math.max(0, Number(cart && cart.total_price) || 0);
  }
  function rewardPlan(cart, tiers, enabled) {
    const updates = {}, missing = [], total = rewardSubtotal(cart);
    for (const tier of tiers || []) {
      if (!tier.gift_handle) continue;
      const lines = (cart.items || []).filter(item => item.handle === tier.gift_handle);
      const qualified = enabled && total >= Number(tier.threshold);
      if (qualified && !lines.length) missing.push(tier.gift_handle);
      lines.forEach((item, index) => {
        const quantity = qualified && index === 0 ? 1 : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
    }
    // Remove the retired complimentary product, never paid promotional items.
    for (const item of cart.items || []) {
      if (Number(item.variant_id) === 48872914223331 && !(tiers || []).some(t => t.gift_handle === item.handle)) updates[item.key] = 0;
    }
    return {updates, missing};
  }
  if (typeof module === 'object' && module.exports) {module.exports={calculate,RULES,displayGroups,itemIdentity,quantityRequest,rewardSubtotal,rewardPlan};return;}
  if (root.SSMultibuy) {root.SSMultibuy.refresh();return;}
  let config, timer, controller, revision=0, latestCart, welcome=false, groupBusy=false;
  const rowGroups=new WeakMap();
  const pendingCartMutations=new Set();
  let rewardsCheckoutBusy=false, rewardsSyncPromise=null, groupTask=Promise.resolve();
  const checkoutSelector='.cart-drawer__dialog [name="checkout"], [data-checkout]';
  const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const $$ = (selector,parent=document) => [...parent.querySelectorAll(selector)];
  function money(value,currency) {
    return new Intl.NumberFormat(config.locale || 'en',{style:'currency',currency:currency||config.currency||'USD'}).format(value/100);
  }
  function html(element, value) {
    if(element.innerHTML===value)return;
    const open=element.querySelector('.ss-mb-drawer-breakdown')?.open;
    element.innerHTML=value;
    if(open) {const details=element.querySelector('.ss-mb-drawer-breakdown');if(details)details.open=true;}
  }
  function beginUpdate() {
    $$('dialog.cart-drawer__dialog').forEach(dialog=>{
      const footer=dialog.querySelector('.cart-drawer__summary');
      if(footer&&!dialog.classList.contains('ss-cart-updating'))dialog.style.setProperty('--ss-summary-reserve',footer.getBoundingClientRect().height+'px');
      dialog.classList.add('ss-cart-updating');dialog.setAttribute('aria-busy','true');
    });
  }
  function endUpdate() {
    $$('dialog.cart-drawer__dialog').forEach(dialog=>{
      dialog.classList.remove('ss-cart-updating');dialog.removeAttribute('aria-busy');dialog.style.removeProperty('--ss-summary-reserve');
    });
  }
  function readConfig() {
    const el=document.querySelector('[data-ss-mb-config]');
    if(!el)return false;
    try {config=JSON.parse(el.textContent);return true;}catch(_){return false;}
  }
  function metadata(cart) {
    const result={};
    for(const item of cart.items) {
      const variant=config.catalog[String(item.variant_id)];
      if(variant && variant.price===item.original_price)result[item.key]={...variant,eligible:variant.compare<=variant.price};
    }
    $$('[data-ss-mb-line]').forEach(el=>{
      const item=cart.items.find(line=>line.key===el.dataset.key && line.original_price===Number(el.dataset.price));
      if(item)result[item.key]={category:el.dataset.category,compare:Number(el.dataset.compare),eligible:el.dataset.eligible==='true',gift:el.dataset.gift==='true'};
    });
    return result;
  }
  function mountDrawer() {
    $$('dialog.cart-drawer__dialog').forEach(dialog=>{
      if(dialog.querySelector('[data-ss-mb-offer="cart"]'))return;
      const target=dialog.querySelector('.cart-items__wrapper');
      const template=document.querySelector('[data-ss-mb-drawer-template]');
      if(target&&template)target.before(template.content.cloneNode(true));
    });
  }
  function lineMarkup(line, preview, currency, group) {
    const format=n=>esc(money(n,currency));
    const rule=RULES[line.category];
    let rewards=line.rewards,saving=line.saving;
    const actualSaving=line.price*line.quantity-Number(line.item.final_line_price);
    const matching=(line.item.line_level_discount_allocations||[]).filter(a=>a.discount_application?.title===rule?.title).reduce((sum,a)=>sum+Number(a.amount||0),0);
    if(!preview && (!line.eligible || matching!==saving || actualSaving!==saving)) {rewards=0;saving=actualSaving;}
    if(line.gift)return '<span class="ss-mb-badge">Complimentary gift</span>';
    let parts=[];
    if(rewards) {
      const paid=line.quantity-rewards;
      if(paid)parts.push(paid+' × '+format(line.price));
      if(rule.rate===1)parts.push(rewards+' × <s>'+format(line.price)+'</s> <strong>FREE</strong>');
      else {
        const rewardTotal=rewards*line.price-saving, low=Math.floor(rewardTotal/rewards), higher=rewardTotal-low*rewards;
        if(rewards-higher)parts.push((rewards-higher)+' × <s>'+format(line.price)+'</s> <strong>'+format(low)+'</strong>');
        if(higher)parts.push(higher+' × <s>'+format(line.price)+'</s> <strong>'+format(low+1)+'</strong>');
      }
    } else {
      parts.push(line.quantity+' × '+(line.sale?'<s>'+format(line.regular/line.quantity)+'</s> ':'')+format(line.price));
    }
    let result='<p class="ss-mb-units">'+parts.join(' <span aria-hidden="true">+</span> ')+'</p>';
    if(line.sale && line.category)result+='<span class="ss-mb-exclusion">Sale · excluded from multi-buy offers</span>';
    if(rewards)result+='<span class="ss-mb-badge">'+(rule.rate===1?'Buy 3, Get 1 Free':'Buy 1, Get 1 50% Off')+'</span>';
    else if(!preview && saving>0)result+='<span class="ss-mb-badge">Item savings −'+format(saving)+'</span>';
    else if(line.eligible && group && group.count%rule.size) {
      const next=rule.size-group.count%rule.size;
      const noun=line.category==='eye-mask'?'eye mask':line.category;
      result+='<span class="ss-mb-nudge">Add '+next+' more '+esc(noun)+(next===1?'':'s')+' in any style '+(rule.rate===1?'to get 1 free.':'to get 50% off the 2nd.')+'</span>';
    }
    return result;
  }
  function groupedControls(row,line) {
    const host=row.querySelector('.cart-items__quantity-controls,[class^="sscp-item-controls-"]');
    if(!host)return;
    let controls=host.querySelector('[data-ss-mb-group-controls]');
    if(line.members.length<2) {
      controls?.remove();Array.from(host.children).forEach(el=>el.classList.remove('ss-mb-group-native'));rowGroups.delete(row);return;
    }
    rowGroups.set(row,line);
    if(!controls) {
      controls=document.createElement('div');controls.dataset.ssMbGroupControls='';controls.className='ss-mb-group-controls';
      controls.innerHTML='<div class="ss-mb-group-stepper"><button type="button" data-ss-mb-group-action="minus" aria-label="Decrease quantity">−</button><input type="number" data-ss-mb-group-quantity min="0" step="1" inputmode="numeric" aria-label="Quantity"><button type="button" data-ss-mb-group-action="plus" aria-label="Increase quantity">+</button></div><button type="button" class="ss-mb-group-remove" data-ss-mb-group-action="remove" aria-label="Remove '+esc(line.item.product_title||line.item.title)+'">'+(row.querySelector('.cart-items__remove svg')?.outerHTML||'Remove')+'</button><span class="ss-mb-group-error" role="alert" hidden></span>';
      host.append(controls);
    }
    Array.from(host.children).forEach(el=>el.classList.toggle('ss-mb-group-native',el!==controls));
    const input=controls.querySelector('input');
    if(document.activeElement!==input)input.value=line.quantity;
    input.defaultValue=line.quantity;
  }
  function groupClick(event) {
    const button=event.target.closest('[data-ss-mb-group-action]');if(!button)return;
    event.preventDefault();event.stopImmediatePropagation();
    const row=button.closest('.cart-items__table-row,[data-line-key]'),group=rowGroups.get(row);if(!group)return;
    const action=button.dataset.ssMbGroupAction;
    groupTask=updateGroup(row,action==='remove'?0:Math.max(0,group.quantity+(action==='plus'?1:-1)));
  }
  function groupChange(event) {
    const input=event.target;if(!input.matches('[data-ss-mb-group-quantity]'))return;
    event.preventDefault();event.stopImmediatePropagation();
    groupTask=updateGroup(input.closest('.cart-items__table-row,[data-line-key]'),input.value.trim()===''?NaN:Number(input.value));
  }
  async function updateGroup(row,target) {
    if(root.SSCartExperience) {
      const group=rowGroups.get(row);
      return root.SSCartExperience.quantity(group?.item, target, group?.identity);
    }
    const group=rowGroups.get(row),input=row.querySelector('[data-ss-mb-group-quantity]'),error=row.querySelector('.ss-mb-group-error');
    if(groupBusy||!group)return;
    if(!Number.isSafeInteger(target)||target<0){input.value=group.quantity;error.textContent='Please enter a whole number of 0 or more.';error.hidden=false;return;}
    if(target===group.quantity)return;
    groupBusy=true;beginUpdate();clearTimeout(timer);++revision;controller?.abort();
    const disabled=$$('.cart-drawer__dialog button,.cart-drawer__dialog input,section[class^="ss-cart-page-"] button,section[class^="ss-cart-page-"] input').map(el=>[el,el.disabled]);
    disabled.forEach(([el])=>el.disabled=true);error.hidden=true;
    let changed=false;
    try {
      const response=await fetch(config.root+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Unable to read your cart. Please try again.');
      const current=await response.json(),members=current.items.filter(item=>itemIdentity(item)===group.identity);
      if(!members.length)throw new Error('Your cart changed. Please try again.');
      const request=quantityRequest(members,target);
      const sections=[...new Set($$('cart-items-component[data-section-id]').map(el=>el.dataset.sectionId))].slice(0,5);
      const result=await fetch(config.root+'cart/'+request.endpoint+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({...request.body,sections,sections_url:location.pathname})});
      const cart=await result.json();
      if(!result.ok||cart.status||cart.errors)throw new Error(cart.description||cart.message||cart.errors||'Unable to update your cart. Please try again.');
      changed=true;
      if(row.closest('section[class^="ss-cart-page-"]')){location.reload();return;}
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'ss-mb-group',data:{itemCount:cart.item_count,sections:cart.sections||{},source:'ss-mb-group'}}}));
      latestCart=cart;
    } catch(failure) {
      input.value=group.quantity;error.textContent=failure.message||'Unable to update your cart. Please try again.';error.hidden=false;
    } finally {
      groupBusy=false;disabled.forEach(([el,value])=>{if(el.isConnected)el.disabled=value;});
      if(changed&&latestCart)render(latestCart);
      refresh();endUpdate();
    }
  }
  function render(cart) {
    latestCart=cart;mountDrawer();
    root.SSCartExperience?.render(cart);
    $$('[data-ss-cart-item-count]').forEach(el=>{
      const excluded=[el.dataset.giftHandleTwo,el.dataset.giftHandleThree].filter(Boolean);
      const count=cart.items.reduce((sum,item)=>sum+(excluded.includes(item.handle)?0:item.quantity),0);
      const label=count+' '+(count===1?'item':'items');
      if(el.textContent!==label)el.textContent=label;
    });
    const preview=config.mode!=='active', meta=metadata(cart), result=calculate(cart,meta,preview&&welcome);
    const format=n=>esc(money(n,cart.currency));
    const groups=displayGroups(result.lines), byKey=new Map();
    groups.forEach(group=>group.members.forEach(line=>byKey.set(line.key,group)));
    const seen=new Map();
    $$('[data-ss-mb-line]').forEach(el=>{
      const line=byKey.get(el.dataset.key);
      const row=el.closest('.cart-items__table-row,[data-line-key]');
      if(!line || !row || Number(el.dataset.price)!==line.price)return;
      const surface=row.closest('.cart-items__wrapper,[data-items]')||row.parentElement;
      if(!seen.has(surface))seen.set(surface,new Set());
      const duplicate=seen.get(surface).has(line.identity);seen.get(surface).add(line.identity);
      row.classList.toggle('ss-mb-group-hidden',duplicate);
      if(duplicate){row.setAttribute('aria-hidden','true');return;}else row.removeAttribute('aria-hidden');
      groupedControls(row,line);
      if(line.gift)row.dataset.ssGiftRow='true';
      html(el,lineMarkup(line,preview,cart.currency,result.groups[line.category]));el.hidden=line.gift;
      row.classList.add('ss-mb-ready');
      const total=row.querySelector('[data-ss-mb-line-total]');
      if(total) {
        const value=preview?line.price*line.quantity-line.saving:Number(line.item.final_line_price);
        html(total,line.gift||value===0?'<strong>FREE</strong>':format(value));total.hidden=false;
      }
    });
    $$('[data-ss-mb-offer="cart"]').forEach(card=>{
      const entries=Object.entries(result.groups).filter(([,g])=>g.count>0);
      card.hidden=entries.length===0;
      const body=card.querySelector('[data-ss-mb-progress]');
      html(body,entries.map(([key,g])=>{
        const rule=RULES[key], next=rule.size-g.count%rule.size;
        const earned=g.rewards?(g.rewards+' '+(rule.rate===1?'free':'50% off')+' '+(g.rewards===1?'item':'items')+(preview?' in preview':'')):'Add '+next+' for '+(rule.rate===1?'1 free item':'50% off the 2nd item');
        const actual=result.lines.filter(l=>l.category===key).reduce((sum,l)=>sum+(l.item.line_level_discount_allocations||[]).filter(a=>a.discount_application?.title===rule.title).reduce((s,a)=>s+Number(a.amount||0),0),0);
        const message=!preview && g.rewards && actual!==g.saving?'Eligible items · savings confirmed at checkout':earned;
        const progress=g.count>0&&g.count%rule.size===0?rule.size:g.count%rule.size;
        return '<div class="ss-mb-progress-row"><div><strong>'+rule.label+'</strong><span>'+message+'</span></div><span class="ss-mb-count">'+g.count+' eligible</span><progress max="'+rule.size+'" value="'+progress+'" aria-label="'+rule.label+' offer progress"></progress></div>';
      }).join(''));
      card.removeAttribute('aria-busy');
    });
    const fullMetadata=cart.items.every(item=>Boolean(meta[item.key]));
    $$('[data-ss-mb-summary]').forEach(el=>{
      if(!cart.items.length || !fullMetadata){el.hidden=true;el.parentElement.classList.remove('ss-mb-summary-ready');return;}
      const row=(label,amount,cls='')=>'<div class="ss-mb-sum-row '+cls+'"><span>'+esc(label)+'</span><span>'+amount+'</span></div>';
      let content=preview?'<p class="ss-mb-preview-label">Offer preview · checkout is unchanged</p>':'';
      content+=row('Items at regular prices',format(result.regular));
      if(result.saleSaving>0)content+=row('Sale savings','−'+format(result.saleSaving));
      if(preview) {
        for(const [key,g] of Object.entries(result.groups))if(g.saving)content+=row(RULES[key].label+' · '+(RULES[key].rate===1?'Buy 3, Get 1':'Buy 1, Get 1 50% Off'),'−'+format(g.saving));
        if(result.welcomeSaving)content+=row('Welcome · 15% off (preview)','−'+format(result.welcomeSaving));
        content+='<label class="ss-mb-welcome"><input type="checkbox" data-ss-mb-welcome'+(welcome?' checked':'')+'>Preview with welcome 15%</label>';
        content+=row('Preview subtotal',format(result.total),'ss-mb-sum-total');
        content+='<p class="ss-mb-saved">Preview savings '+format(result.regular-result.total)+'</p><p class="ss-mb-fine">This preview models multi-buy offers and optional welcome 15% only. No code is applied. Checkout still uses the current live discounts.</p>';
      } else {
        const actualDiscounts=new Map();
        for(const line of result.lines)for(const a of line.item.line_level_discount_allocations||[]) {
          const title=a.discount_application?.title||'Item discount';
          actualDiscounts.set(title,(actualDiscounts.get(title)||0)+Number(a.amount||0));
        }
        for(const [title,amount] of actualDiscounts)if(amount){
          const offer=Object.values(RULES).find(rule=>rule.rate===0.5&&rule.title===title);
          content+=row(offer?offer.label+' · Buy 1, Get 1 50% Off':title,'−'+format(amount));
        }
        for(const discount of cart.cart_level_discount_applications||[])if(discount.total_allocated_amount)content+=row(discount.title,'−'+format(discount.total_allocated_amount));
        const accounted=result.current-[...actualDiscounts.values()].reduce((a,b)=>a+b,0)-(cart.cart_level_discount_applications||[]).reduce((s,d)=>s+Number(d.total_allocated_amount||0),0);
        if(accounted!==cart.total_price){el.hidden=true;el.parentElement.classList.remove('ss-mb-summary-ready');return;}
        if(result.regular>cart.total_price)content+='<p class="ss-mb-saved">You save '+format(result.regular-cart.total_price)+'</p>';
      }
      if(el.closest('.cart-drawer__dialog,section[class^="ss-cart-page-"]')) {
        const returns=el.parentElement.querySelector('.ss-mb-returns');
        if(returns){content+=returns.outerHTML;if(!el.contains(returns))returns.remove();}
        const summary=preview?'<span>Offer preview</span><strong>'+format(result.total)+'</strong>':'<span>Savings breakdown</span>';
        content='<details class="ss-mb-drawer-breakdown"><summary>'+summary+'</summary><div class="ss-mb-breakdown-body">'+content+'</div></details>';
      }
      html(el,content);el.hidden=false;el.parentElement.classList.add('ss-mb-summary-ready');
      const parent=el.parentElement;
      const totalLabel=parent.querySelector('.cart-totals__total-label,[data-ss-mb-actual-label]');
      if(totalLabel) {
        if(!totalLabel.dataset.ssOriginalLabel)totalLabel.dataset.ssOriginalLabel=totalLabel.textContent;
        totalLabel.textContent='Subtotal';
      }
    });
    document.documentElement.classList.add('ss-mb-enhanced');
  }
  function invalidate() {
    $$('.ss-mb-group-hidden').forEach(row=>{row.classList.remove('ss-mb-group-hidden');row.removeAttribute('aria-hidden');});
    $$('.ss-mb-group-native').forEach(el=>el.classList.remove('ss-mb-group-native'));
    $$('[data-ss-mb-group-controls]').forEach(el=>el.remove());
    $$('[data-ss-mb-line]').forEach(el=>{el.hidden=true;el.closest('.cart-items__table-row,[data-line-key]')?.classList.remove('ss-mb-ready');});
    $$('[data-ss-mb-line-total]').forEach(el=>{el.hidden=true;});
    $$('[data-ss-mb-summary]').forEach(el=>{el.hidden=true;el.parentElement.classList.remove('ss-mb-summary-ready');});
    $$('[data-ss-mb-offer="cart"]').forEach(el=>{el.setAttribute('aria-busy','true');const status=el.querySelector('[data-ss-mb-progress]');if(status)html(status,'<p>Updating your offers…</p>');});
  }
  function refresh() {
    if(groupBusy)return;
    if(!config&&!readConfig())return;
    clearTimeout(timer);controller?.abort();const current=++revision;
    timer=setTimeout(async()=>{
      const request=new AbortController();controller=request;
      const timeout=setTimeout(()=>request.abort(),10000);
      try {
        const response=await fetch(config.root+'cart.js',{credentials:'same-origin',cache:'no-store',signal:request.signal,headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error('Cart unavailable');
        const cart=await response.json();
        if(current===revision&&Array.isArray(cart.items)){render(cart);endUpdate();}
      }catch(_){
        if(current===revision){invalidate();endUpdate();$$('[data-ss-mb-offer="cart"]').forEach(el=>{el.hidden=true;});}
      }finally{clearTimeout(timeout);}
    },120);
  }
  async function rewardRequest(path, body) {
    const controller=new AbortController(), timeout=setTimeout(()=>controller.abort(),15000);
    try {
      const response=await fetch(config.root+path,{credentials:'same-origin',cache:'no-store',signal:controller.signal,
        headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},
        ...(body?{method:'POST',body:JSON.stringify(body)}:{})});
      const data=await response.json();
      if(!response.ok||data.status||data.errors)throw new Error('Unable to confirm your gifts. Please try again.');
      return data;
    } finally {clearTimeout(timeout);}
  }
  async function waitForCartMutations() {
    // Response bodies must settle too: HTTP headers alone are not completion.
    while(pendingCartMutations.size) await Promise.all([...pendingCartMutations]);
  }
  async function reconcileRewards() {
    let changed=false;
    const tiers=root.SS_CARTPAGE_TIER_CONFIG||root.SS_TIER_CONFIG;
    for(let attempt=0;attempt<5;attempt++) {
      await waitForCartMutations();
      const cart=await rewardRequest('cart.js');
      if(!tiers) return {cart,changed};
      const plan=rewardPlan(cart,tiers.tiers,tiers.enabled!==false&&tiers.gifts_enabled!==false);
      if(!Object.keys(plan.updates).length&&!plan.missing.length) return {cart,changed};
      if(Object.keys(plan.updates).length) {
        await rewardRequest('cart/update.js',{updates:plan.updates});
        changed=true;
        continue; // Re-read keys, eligibility and missing gifts after each write.
      }
      const items=[];
      for(const handle of plan.missing) {
        const product=await rewardRequest('products/'+encodeURIComponent(handle)+'.js');
        const variant=product.variants?.[0];
        if(!variant||Number(variant.price)!==0||variant.available===false) throw new Error('Your complimentary gift is unavailable. Please try again or contact us.');
        items.push({id:variant.id,quantity:1});
      }
      await rewardRequest('cart/add.js',{items});
      changed=true;
    }
    throw new Error('Your cart changed. Please review your gifts and try checkout again.');
  }
  function syncRewards() {
    if(rewardsSyncPromise) return rewardsSyncPromise;
    const run=()=>reconcileRewards();
    // Coordinate the two cart surfaces, and tabs in browsers supporting Web Locks.
    rewardsSyncPromise=(root.navigator?.locks
      ? root.navigator.locks.request('silksilq-cart-gifts',run) : run())
      .finally(()=>{rewardsSyncPromise=null;});
    return rewardsSyncPromise;
  }
  async function prepareRewardsCheckout() {
    await root.SSCartExperience?.whenIdle();
    await Promise.all($$('cart-items-component').map(component=>component.whenIdle?.()));
    await groupTask;
    await Promise.all([root.SSCartPageGiftIdle?.(),root.SSDrawerGiftIdle?.()]);
    await waitForCartMutations();
    if(root.SSGiftReceipt && !await root.SSGiftReceipt.flush()) throw new Error('Please save your gift receipt preference before checkout.');
    await waitForCartMutations();
    const result=await syncRewards();
    if(!result.cart.items?.length) throw new Error('Your cart is empty. Please add an item before checkout.');
    return result.cart;
  }
  function checkoutDeadline(task) {
    let timer;
    return Promise.race([task,new Promise((_,reject)=>{
      timer=setTimeout(()=>reject(new Error('This is taking longer than expected. Refresh your cart and try again.')),30000);
    })]).finally(()=>clearTimeout(timer));
  }
  async function rewardsCheckout(event) {
    const button=event.type==='submit'
      ? (event.submitter||event.target.querySelector?.('[name="checkout"]')||document.querySelector('.cart-drawer__dialog [name="checkout"][form="'+event.target.id+'"]'))
      : event.target.closest(checkoutSelector);
    if(!button||!button.matches(checkoutSelector)) return;
    event.preventDefault();event.stopImmediatePropagation();
    if(rewardsCheckoutBusy||button.disabled) return;
    rewardsCheckoutBusy=true;
    root.SSCartExperience?.checkoutState(true);
    const scope=button.closest('.cart-drawer__dialog,section[class^="ss-cart-page-"]')||document.querySelector('[data-ss-cart-page]');
    let status=scope.querySelector('[data-ss-reward-checkout-status]');
    if(!status){status=document.createElement('p');status.dataset.ssRewardCheckoutStatus='';status.setAttribute('role','status');(scope.querySelector('[data-ss-cart-amounts]')||button.parentElement).append(status);}
    status.textContent='Checking your cart…';
    button.setAttribute('aria-busy','true');
    try {
      await checkoutDeadline(prepareRewardsCheckout());
      // Never submit stale hidden quantities or a stale note after verification.
      root.location.assign(config.root+'checkout');
    } catch(error) {
      rewardsCheckoutBusy=false;button.removeAttribute('aria-busy');
      root.SSCartExperience?.checkoutState(false, error.message);
      status.textContent=error.message||'Unable to confirm your cart. Please try again.';
      status.setAttribute('role','alert');
      if(!status.isConnected) {
        const target=document.querySelector(checkoutSelector);
        if(target) target.before(status);
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));refresh();
    }
  }
  function start() {
    if(!readConfig())return;
    root.SSMultibuy={refresh,calculate,metadata,rewardSubtotal,syncRewards,itemIdentity,quantityRequest,waitForCartMutations,get rewardsCheckoutBusy(){return rewardsCheckoutBusy;}};
    document.addEventListener('click',rewardsCheckout,true);
    document.addEventListener('submit',rewardsCheckout,true);
    ['click','change','submit'].forEach(type=>document.addEventListener(type,event=>{
      if(rewardsCheckoutBusy&&event.target.closest('.cart-drawer__dialog,section[class^="ss-cart-page-"]')){
        event.preventDefault();event.stopImmediatePropagation();
      }
    },true));
    document.addEventListener('click',groupClick,true);
    document.addEventListener('change',groupChange,true);
    document.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches('[data-ss-mb-group-quantity]')){event.preventDefault();groupChange(event);}},true);
    try{welcome=sessionStorage.getItem('ss-mb-welcome-preview')==='true';}catch(_){}
    document.addEventListener('change',event=>{
      if(!event.target.matches('[data-ss-mb-welcome]'))return;
      welcome=event.target.checked;try{sessionStorage.setItem('ss-mb-welcome-preview',String(welcome));}catch(_){}
      if(latestCart)render(latestCart);
    });
    const originalFetch=root.fetch;
    root.fetch=function(input,init) {
      let mutation=false;
      try{const url=new URL(typeof input==='string'||input instanceof URL?input:input.url,location.href);mutation=url.origin===location.origin&&/\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);}catch(_){}
      if(mutation){++revision;clearTimeout(timer);controller?.abort();beginUpdate();}
      let timeout, aborter;
      if(mutation) {
        aborter=new AbortController();
        const signal=init?.signal||(typeof input==='object'?input.signal:null);
        if(signal?.aborted)aborter.abort();
        else signal?.addEventListener('abort',()=>aborter.abort(),{once:true});
        timeout=setTimeout(()=>aborter.abort(),15000);
        init={...init,signal:aborter.signal};
      }
      const promise=originalFetch.call(this,input,init);
      if(mutation){
        const settled=promise.then(response=>response.clone().text().then(()=>{},()=>{}),()=>{});
        pendingCartMutations.add(settled);
        settled.then(()=>{clearTimeout(timeout);pendingCartMutations.delete(settled);refresh();});
      }
      return promise;
    };
    ['cart:updated','cart:update','cart:refresh','dialog:open'].forEach(name=>document.addEventListener(name,refresh));
    window.addEventListener('pageshow',()=>{
      rewardsCheckoutBusy=false;
      root.SSCartExperience?.checkoutState(false);
      $$('[data-ss-reward-checkout-status]').forEach(el=>el.remove());
      $$(checkoutSelector).forEach(el=>el.removeAttribute('aria-busy'));
      refresh();document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
    document.addEventListener('shopify:section:load',()=>{readConfig();refresh();});
    new MutationObserver(records=>{
      const changed=records.some(record=>record.type==='attributes'?record.target.matches('dialog.cart-drawer__dialog'):Array.from(record.addedNodes).some(node=>node.nodeType===1&&(node.matches('[data-ss-mb-line],.cart-items__wrapper,[data-ss-mb-summary]')||node.querySelector('[data-ss-mb-line],.cart-items__wrapper,[data-ss-mb-summary]'))));
      if(changed&&!groupBusy){
        mountDrawer();
        if(latestCart)render(latestCart);
        refresh();
      }
    }).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['open']});
    refresh();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})(typeof window==='undefined'?globalThis:window);




